
import './App.css';
import Home from '../src/Components/Home';
function App() {
  return (
    <div className="App">
    <Home />
    </div>
  );
}

export default App;
